/** SOURCE: https://clark.engineering/input-on-android-229-unidentified-1d92105b9a04 */

/**
 * A normalized event from InputEvent and KeyboardEvent that works from ie11
 * over modern browsers to android browsers (because that beast is worse than ie6)
 */
export interface CompatibleInputEvent {
  key?: string;
  inputType?: string;
  navigationType?: string;
  originalEvent:
    React.KeyboardEvent<HTMLDivElement> | React.FormEvent<HTMLDivElement>;
}

export const normalizeInputEvent = function (
  event: React.KeyboardEvent<HTMLDivElement> | React.FormEvent<HTMLDivElement>
): CompatibleInputEvent {
  const e: CompatibleInputEvent = {
    originalEvent: event,
  };

  if (event.nativeEvent instanceof KeyboardEvent) {
    if (event.nativeEvent.key === 'Backspace') {
      e.inputType = 'deleteContentBackward';
      e.navigationType = 'cursorLeft';
    } else if (event.nativeEvent.key === 'Delete') {
      e.inputType = 'deleteContentForward';
    } else if (event.nativeEvent.key.startsWith('Arrow')) {
      e.navigationType = event.nativeEvent.key.replace('Arrow', 'cursor');
    } else {
      e.key = event.nativeEvent.key;
      e.inputType = 'insertText';
    }
  } else if (event.nativeEvent instanceof InputEvent) {
    const { inputType } = event.nativeEvent;
    e.inputType = inputType;
    e.key = event.nativeEvent.data ?? undefined;

    if (inputType === 'insertText') {
      e.navigationType = 'cursorRight';
    }
  }

  return e;
};
